<app-home-top-bar></app-home-top-bar>

<router-outlet></router-outlet>

<app-home-footer></app-home-footer>